import { Form } from "antd"
import { useContext, useMemo, useState } from "react"
import { ReactComponent as PEOPLE } from "../../../assets/People.svg"
import { ReactComponent as TASKS } from "../../../assets/Task.svg"
import BaseInputField from "../../../components/elements/BaseInputField"
import BaseInputSelection from "../../../components/elements/BaseInputSelection"
import BaseModal from "../../../components/layout/BaseModal"
import { ModalContext } from "../../../components/contexts/ModalContext"
import { TourEmployeeRef } from "../types"

type AddTourModalType = {
    modalId: number
    employees: TourEmployeeRef[]
    employeesLoading: boolean
    onSearchEmployee: (search: string) => void
    onSave: (data: { name: string; employee?: TourEmployeeRef }) => void
}

export default function AddTourModal(props: AddTourModalType) {
    const [form] = Form.useForm()
    const modalCon = useContext(ModalContext)
    const [name, setName] = useState("")
    const [employeeId, setEmployeeId] = useState("")
    const [pickedEmployee, setPickedEmployee] = useState<TourEmployeeRef | undefined>()

    const employees = useMemo(() => {
        const list = props.employees ?? []
        if (pickedEmployee && !list.some((item) => item._id === pickedEmployee._id)) return [pickedEmployee, ...list]
        return list
    }, [props.employees, pickedEmployee])

    const reset = () => {
        setName("")
        setEmployeeId("")
        setPickedEmployee(undefined)
        form.resetFields()
    }

    const setEmployee = (id: string) => {
        setEmployeeId(id)
        if (!id) {
            setPickedEmployee(undefined)
            return
        }
        setPickedEmployee(employees.find((item) => item._id === id) ?? pickedEmployee)
    }

    return (
        <Form
            form={form}
            onFinish={() => {
                if (!name.trim()) return
                props.onSave({ name: name.trim(), employee: employeeId ? pickedEmployee : undefined })
                reset()
                modalCon?.trigger(props.modalId)
            }}>
            <BaseModal
                modalId={props.modalId}
                size="fit"
                title="Tour anlegen"
                onOpen={reset}
                bottomRow={
                    <div className="flex justify-end w-full">
                        <Form.Item className="mb-0">
                            <button className="btn btn-primary" type="submit" disabled={!name.trim()}>
                                Anlegen
                            </button>
                        </Form.Item>
                    </div>
                }>
                <p className="text-sm text-gray-500 px-2 pt-4 pb-2">Wöchentlicher Fahrplan (Mo–Fr). Objekte legen Sie danach in der Tour fest.</p>
                <div className="flex flex-col gap-4 px-2 pb-2">
                    <div className="flex gap-3 items-start">
                        <TASKS className="w-6 h-6 shrink-0 mt-8 text-primary" />
                        <Form.Item className="mb-0 w-full" name="name" rules={[{ required: true, message: "Bitte ausfüllen!" }]}>
                            <BaseInputField label="Name *" type="text" placeholder="z. B. Chemnitz Nord" onChange={setName} />
                        </Form.Item>
                    </div>
                    <div className="flex gap-3 items-start">
                        <PEOPLE className="w-6 h-6 shrink-0 mt-8 text-primary" />
                        <BaseInputSelection
                            label="Mitarbeiter"
                            placeholder="Nicht zugewiesen"
                            data={employees}
                            value={employeeId || undefined}
                            setId={setEmployee}
                            onSearch={props.onSearchEmployee}
                            customLoading={props.employeesLoading}
                            allowClear
                        />
                    </div>
                </div>
            </BaseModal>
        </Form>
    )
}
